import api from '../../../services/api';

const BASE_URL = '/stock';

const DEFAULT_PAGINATION = {
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
};

const stockService = {
  async getStock(params = {}) {
    const response = await api.get(BASE_URL, { params });
    const result = response.data?.data;

    return {
      stock: Array.isArray(result)
        ? result
        : Array.isArray(result?.stock)
          ? result.stock
          : [],
      pagination: {
        ...DEFAULT_PAGINATION,
        ...(response.data?.pagination || result?.pagination || {}),
      },
    };
  },

  async getStockByProductId(productId) {
    if (
      productId === undefined ||
      productId === null ||
      productId === ''
    ) {
      throw new Error('Product ID is required.');
    }

    const response = await api.get(
      `${BASE_URL}/${encodeURIComponent(productId)}`
    );

    const result = response.data?.data;

    return result?.stock ?? result ?? null;
  },
};

export default stockService;